
import type { SVGProps } from 'react';
const SvgVisibility = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#visibility_svg__a)">
      <path
        fill="#263E6A"
        d="M12.005 15.154q1.524 0 2.586-1.067 1.063-1.067 1.063-2.591t-1.067-2.587-2.591-1.063-2.587 1.067-1.063 2.592 1.067 2.586q1.066 1.063 2.592 1.063M12 14.2q-1.125 0-1.912-.787A2.6 2.6 0 0 1 9.3 11.5q0-1.125.787-1.912A2.6 2.6 0 0 1 12 8.8q1.125 0 1.912.787.788.788.788 1.913t-.787 1.912A2.6 2.6 0 0 1 12 14.2m.003 3.8q-3.249 0-5.922-1.768T2.077 11.5q1.33-2.964 4.001-4.732Q8.748 5 11.998 5t5.921 1.768 4.004 4.732q-1.33 2.964-4.001 4.732Q15.252 18 12.002 18M12 17a9.54 9.54 0 0 0 5.188-1.488A9.77 9.77 0 0 0 20.8 11.5a9.77 9.77 0 0 0-3.613-4.012A9.55 9.55 0 0 0 12 6a9.55 9.55 0 0 0-5.188 1.487A9.77 9.77 0 0 0 3.2 11.5a9.77 9.77 0 0 0 3.612 4.012A9.54 9.54 0 0 0 12 17"
      />
    </g>
    <defs>
      <clipPath id="visibility_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgVisibility;
